import { render, staticRenderFns } from "./ss-contact-us-new.vue?vue&type=template&id=404c840e"
import script from "./ss-contact-us-new.vue?vue&type=script&lang=js"
export * from "./ss-contact-us-new.vue?vue&type=script&lang=js"
import style0 from "./ss-contact-us-new.vue?vue&type=style&index=0&id=404c840e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports